<ng-container content>
    <div *ngIf="!hasReadPermission()">{{localizationKeys.aumico_reports_write_permission_error | i18next}}</div>
    <div *ngIf="hasWritePermission()" class="general-information">
        <div class="company-update-banner-container">
            <app-update-banner
                *ngIf="showUpdateCompanyBanner"
                style="margin-bottom: 16px"
                messageLocalizationKey="aumico_company_update_banner_message"
                buttonLocalizationKey="aumico_company_update_banner_button"
                (confirm)="onUpdateCompanyInformationButtonClick()"
            >
            </app-update-banner>
        </div>

        <!-- General Information Component -->
        <aumico-general-information-v2
            *ngIf="setupData || savedData"
            [mode]="mode"
            [currentLanguage]="currentLanguage"
            [setupData]="setupData"
            [companies]="companies"
            [accountingBases]="accountingBasesFilteredSelections"
            [arTemplates]="arTemplatesOptions"
            [currencies]="currenciesFilteredSelections"
            [reportTypes]="reportTypes"
            [reportLanguages]="locales"
            [isCpmmActive]="isCpmmActive"
            [savedData]="savedData"
            [previousAnnualReportOptions]="previousAnnualReportOptions"
            (companySelected)="companySelectionChange($event)"
            (accountingBasisSelected)="accountingBasisSelectionChange($event)"
            (arTemplateSelected)="arTemplateSelectionChange($event)"
            (autofillReportForBalanceSelected)="autofillReportForBalanceSelectionChange($event)"
            (autofillReportForIncomeSelected)="autofillReportForIncomeSelectionChange($event)"
            (formDataChanged)="onFormDataChanged($event)"
            (formValidChanged)="onFormValidChanged($event)"
        ></aumico-general-information-v2>

        <aum-form-error *ngIf="isBackendReturnError" class="alert alert-danger">
            <span>{{ backendErrors | i18next}}</span>
        </aum-form-error>
    </div>
</ng-container>
<ng-template #footerTemplate>
    <aum-action-bar-pure
        [extraActionButtons]="footerExtraButtonActions"
        nextButtonPrefixText="{{nextStepPrefix | i18next}}"
        nextButtonText="{{nextStepLabel | i18next}}"
        nextButtonRouterLink="../{{nextStepPath}}"
        [nextButtonAction]="proceedButtonClicked"
        [nextButtonDisabled]="disableProceedButton"
    ></aum-action-bar-pure>
</ng-template>
<redo-annual-report class="archive-wrapper" (redoReport)="onArchiveAndGenerateNewReport()"></redo-annual-report>
<app-loading-spinner [active]="showSpinner"></app-loading-spinner>
